// en.js 
export default {
  loginRegisterH:{
    back:"返回首页",
    industry:"产业工作台",
    business:"企业工作台",
    welcome: "欢迎登录",
    noAccount:"还没账号？",
    toRegister: "去注册",
    yesAccount:"已有账号，",
    toLogin:"去登录",
  }
}